export class ProposalSearchVO {
    public searchId: String;
    public searchInput: String;
    public searchBranchId: String;
    public searchBranchInput: String;
}
